// extracted by mini-css-extract-plugin
export default {"contacts_section":"contactsSection_contacts_section__IT46B","map":"contactsSection_map__G2W9D"};